export interface Notification {
    id?: string;
    title: string;
    message: string;
    isRequired: boolean;
    url?: string;
    type: NotificationType;
    createdAt?: Date;
    updatedAt?: Date;
}

export enum NotificationType {
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    UPDATE = 'update',
}
